import { createContext } from 'react';

export type TQuillInactiveContext = { hidden: boolean };
export const QuillInactiveContext = createContext<TQuillInactiveContext>({ hidden: false });
